<template>
  <div>
    <div class="d-none d-md-block">
      <v-timeline align-top dense v-if="!isAnneversariesEmpty()">
        <timeline-regular :data="{ ...anneversaries.today, title: 'Today' }" />
        <timeline-regular
          :data="{ ...anneversaries.tomorrow, title: 'Tomorrow' }"
        />
        <timeline-regular
          :data="{ ...anneversaries.next, title: 'Upcoming' }"
        />
      </v-timeline>
      <div v-else>
        <v-img src="/no-celebrations.svg" :contain="true" height="300" />
      </div>
    </div>

    <div class="d-md-none">
      <div v-if="!isAnneversariesEmpty()">
        <timeline-small :data="{ ...anneversaries.today, title: 'Today' }" />
        <v-divider />
        <timeline-small
          :data="{ ...anneversaries.tomorrow, title: 'Tomorrow' }"
        />
        <v-divider />
        <timeline-small :data="{ ...anneversaries.next, title: 'Upcoming' }" />
      </div>
      <div v-else>
        <v-img src="/no-celebrations.svg" :contain="true" height="300" />
      </div>
    </div>
  </div>
</template>

<script>
import TimelineRegular from "@/views/protected/dashboard/timeline-regular";
import TimelineSmall from "@/views/protected/dashboard/timeline-small";

export default {
  name: "ActivitiesAnniversary",
  props: ["anneversaries"],
  components: {
    TimelineSmall,
    TimelineRegular,
  },
  methods: {
    isAnneversariesEmpty() {
      if (!this.anneversaries) return true;
      if (
        !this.anneversaries.next &&
        !this.anneversaries.today &&
        !this.anneversaries.tomorrow
      ) {
        return true;
      }
      if (
        !this.anneversaries.next.data &&
        !this.anneversaries.tomorrow.data &&
        !this.anneversaries.today.data
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
</style>
